import {
  getCommonDashboard,
  addFavoriteApp,
  getNewsAndAnnouncementDetails,
  setAttachments,
  toggleAttachmentsLoading,
  uploadAttachments,
  removeAttachment,
  globalLoaderText,
} from "./actions";

const dispatchCommonDashboard = (dispatch: Function) => (user: any) => {
  dispatch(getCommonDashboard(user));
};

const dispatchAddFavoriteApp = (dispatch: Function) => (favApp: any) => {
  dispatch(addFavoriteApp(favApp));
};

const dispatchGetNewsAndAnnouncementDetail =
  (dispatch: Function) => (reqBody: any) => {
    dispatch(getNewsAndAnnouncementDetails(reqBody));
  };

const dispatchSetAttachments = (dispatch: Function) => (fileList: Array<any>) =>
  dispatch(setAttachments(fileList));

const dispatchRemoveAttachment = (dispatch: Function) => (index: number) =>
  dispatch(removeAttachment(index));

const dispatchToggleAttachmentsLoading =
  (dispatch: Function) => (value: boolean) =>
    dispatch(toggleAttachmentsLoading(value));

const dispatchUploadAttachments = (dispatch: Function) => (obj: any) =>
  dispatch(uploadAttachments(obj));

const dispatchGlobalLoaderText = (dispatch: Function) => (obj: any) =>
  dispatch(globalLoaderText(obj));

const operations = {
  dispatchCommonDashboard,
  dispatchAddFavoriteApp,
  dispatchGetNewsAndAnnouncementDetail,
  dispatchToggleAttachmentsLoading,
  dispatchSetAttachments,
  dispatchUploadAttachments,
  dispatchRemoveAttachment,
  dispatchGlobalLoaderText
};

export default operations;
